import { trpc } from "../trpc";

import useAccountRestriction from "../account/useAccountRestriction";

interface Input {
  enabled?: boolean;
  zapId?: string;
}

interface Return {
  publishedRequiresApproval: boolean;
  pauseRequiresApproval: boolean;
  isLoadingRequiresApproval: boolean;
}

function useRequiresApproval({ enabled = true, zapId }: Input): Return {
  const { isPublishApprovalEnabled, isLoading: isAccountRestrictionLoading } =
    useAccountRestriction();

  const { data, isLoading } = trpc.approval.requiresApproval.useQuery(
    { zapId },
    {
      enabled:
        enabled && !isAccountRestrictionLoading && !!isPublishApprovalEnabled,
    },
  );

  return {
    publishedRequiresApproval: data?.published_requires_approval ?? false,
    pauseRequiresApproval: data?.pause_requires_approval ?? true,
    isLoadingRequiresApproval: isLoading || isAccountRestrictionLoading,
  };
}

export default useRequiresApproval;
